import React from 'react'
import Header from '../../component/Header'
import AboutUs from '../AboutUs'
import Footer from '../../component/Footer'
import Postgraduate from '../Postgraduate'

export default function LayoutPostGraduate() {
    return (
        <div>
            <Header />
            <Postgraduate />
            <Footer />
        </div>
    )
}
